// Downscale an image file in the browser → JPEG data URL (keeps PNG transparency when small).
export const compressImage = (file, maxSize = 800, quality = 0.82) =>
  new Promise((resolve, reject) => {
    if (!file || !file.type.startsWith("image/")) return reject(new Error("Arquivo inválido"));
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
      const w = Math.max(1, Math.round(img.width * scale));
      const h = Math.max(1, Math.round(img.height * scale));
      const canvas = document.createElement("canvas");
      canvas.width = w; canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, w, h);
      URL.revokeObjectURL(url);
      const png = file.type === "image/png" && file.size < 300_000;
      resolve(canvas.toDataURL(png ? "image/png" : "image/jpeg", quality));
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Não foi possível ler a imagem")); };
    img.src = url;
  });
